import { Component, inject, signal } from "@angular/core";
import { takeUntilDestroyed, toSignal } from "@angular/core/rxjs-interop";
import { RouterOutlet } from "@angular/router";
import { RootRouterStore } from "@dcc/vestas-online/data-access";
import { SidebarComponent } from "@dcc/vestas-online/notification-area/feat";
import { UserAlertComponent } from "@dcc/vestas-online/platform-alerts/feat";
import { provideComponentStore } from "@ngrx/component-store";
import { map } from "rxjs";
import { HeaderComponent } from "../header/header.component";
import { NavDrawerService } from "../nav-drawer.service";
import { NavDrawerComponent } from "../nav-drawer/nav-drawer.component";
import { AlertContainer } from "@dcc/vestas-online/alerts/feat-alerts";

@Component({
    selector: "vo-shell-app",
    templateUrl: "./shell.component.html",
    host: {
        class: "h-dvh flex flex-col overflow-hidden print:static print:z-auto print:block print:overflow-auto"
    },
    imports: [HeaderComponent, UserAlertComponent, NavDrawerComponent, RouterOutlet, SidebarComponent, AlertContainer],
    providers: [provideComponentStore(RootRouterStore)]
})
export class ShellComponent {
    public navDrawerOpen = signal(false);
    private rootRouterStore = inject(RootRouterStore);
    public routeTitle = toSignal(this.rootRouterStore.route$.pipe(map(({ title }) => title)), { initialValue: "" });
    private navDrawerService = inject(NavDrawerService);

    constructor() {
        this.navDrawerService
            .drawerOpen$()
            .pipe(takeUntilDestroyed())
            .subscribe(() => {
                this.navDrawerOpen.set(false);
            });
    }

    public openDrawer(): void {
        this.navDrawerOpen.set(true);
    }

    public drawerHidden(): void {
        this.navDrawerOpen.set(false);
    }
}
